class ActiveSessionsAppDatatable {
    constructor(){
        this.datatable = this.init('#active-sessions-app-datatable');
        this.initActions();
    }
    init(el){
        let thisClass = this;
        const datatable = $(el).DataTable({
            searchDelay: 400,
            processing: true,
            serverSide: true,
            stateSave: false,
            order: [[2, 'desc']],
            info: true,
            paging: true,
            ajax: {
                url: '?do=getAppActiveSessions',
                type: 'POST',
            },
            language: {
                emptyTable: "No data found"
            },
            dom:
                "<'table-responsive'tr>" +
                "<'row'" +
                "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'li>" +
                "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'p>" +
                ">",
            drawCallback: function(settings) {
                // Remove all visible popovers after datatable draw
                document.querySelectorAll('.popover.fade.show').forEach(function (el) {
                    el.remove();
                });
                // Init all popovers after datatable draw
                const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });
                // init page length select
                $('select[name=active-sessions-app-datatable_length]').select2({minimumResultsForSearch: -1});
                // Add delay to datatable search
                // new DatatableSearchDelay(datatable, '#sign_in_attempts_tab [data-kt-docs-table-filter=search]');
            },
            columns: [
                {
                    data: 'os',
                    title: 'Operating System',
                    sortable: true,
                    className: 'min-w-150px',
                    render: function (data, type, row) {
                        return '<div class="d-flex align-items-center" data-cy="app-operating-system">' +
                            '       <div class="symbol symbol-40px me-3 border ga-border-primary-300 symbol-circle">' +
                            '           <div class="symbol-label bg-light-primary border border-2 border-white">' +
                            (row['os'] !== 'Unknown' ? '<img src="/media/goodaccess/icons/os/' + row['os'] + '.svg" alt="avatar">' : '<i class="fa-solid fa-question fs-1"></i>') +
                            '           </div>' +
                            '       </div>' +
                            '       <div class="d-flex justify-content-start flex-column">' +
                            '           <div><span class="fw-bold text-primary mb-1 fs-6">'+row['os']+'</span></div>' +
                            '       </div>' +
                            '   </div>';
                    }
                },
                {
                    data: 'city',
                    title: 'Origin location',
                    sortable: true,
                    className: 'min-w-150px',
                    render: function (data, type, row) {
                        return '<div class="d-flex align-items-center" data-cy="location-app">' +
                            '       <div class="symbol symbol-40px me-3 border ga-border-primary-300 symbol-circle">' +
                            '           <div class="symbol-label bg-light-primary border border-2 border-white overflow-hidden">' +
                            (row['iso2'] ? '<img src="/media/goodaccess/country-flags/png100px/' + row['iso2'] + '.png" class="h-40px" alt="flag">' : '<i class="fa-solid fa-question fs-1"></i>') +
                            '           </div>' +
                            '       </div>' +
                            '       <div class="d-flex justify-content-start flex-column">' +
                            (row['iso2'] ? '<div><span class="fw-bold text-primary mb-1 fs-6">'+row['iso2'].toUpperCase()+' - '+ row['city'] + '</span></div>' : '') +
                            '           <span class="fw-semibold d-block fs-7 ga-text-primary-800">' + row["ip"] + '</span>' +
                            '       </div>' +
                            '   </div>';
                    }
                },
                {
                    data: 'timestamp',
                    title: 'Session Started',
                    sortable: true,
                    render: function (data, type, row) {
                        return `<span data-bs-toggle="popover" data-bs-trigger="hover" data-bs-placement="bottom" data-bs-content="${row['time']}<br>${row['date']}" data-bs-html="true">${row['timeDiff']}</span>`;
                    }
                },
                {
                    data: 'sessionID',
                    title: 'Action',
                    sortable: false,
                    render: function (data, type, row) {
                        if(row['currentSession']){
                            return '<span class="badge badge-light-primary">Current</span>';
                        }
                        return '<span class="text-decoration-underline-ga danger text-danger sign-out-app-session" data-action-id="'+row['sessionID']+'">Sign Out</span>';
                    }
                }
            ]
        }).on('draw.dt', function () {
            if(datatable.page.info().recordsTotal === 0){
                $('#active-sessions-app-datatable_wrapper').hide();
                $('#active-sessions-app-datatable_no-results').addClass('d-flex flex-center flex-column').removeClass('d-none');
            } else {
                $('#active-sessions-app-datatable_wrapper').show();
                $('#active-sessions-app-datatable_no-results').addClass('d-none').removeClass('d-flex flex-center flex-column');
            }
        });
        return datatable;
    }
    initActions() {
        const thisClass = this;
        $(document).on('click', '.sign-out-app-session', function (e) {
            let sessionID = $(this).attr('data-action-id');
            Swal.fire({
                html: `<span class="text-center text-primary">Are you sure you want to sign out this session?</span>`,
                icon: "warning",
                iconColor: "#FF5206",
                buttonsStyling: false,
                reverseButtons: true,
                showCancelButton: true,
                confirmButtonText: "Yes, sign out!",
                customClass: {
                    confirmButton: "btn btn-danger mt-0",
                    cancelButton: 'btn btn-light-primary mt-0',
                },
                showLoaderOnConfirm: true,
                returnFocus: false,
                preConfirm: () => {
                    return fetch('/security-settings?do=signOutAppSession&sessionID='+sessionID)
                        .then(response => {
                            if (!response.ok) {
                                throw new Error(response.statusText)
                            }
                            return response.json();
                        }).catch(error => {
                            Swal.showValidationMessage(`Request failed: ${error}`)
                        });
                },
                allowOutsideClick: () => !Swal.isLoading(),
                allowEscapeKey: () => !Swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    if (result.value === 'signedOut') {
                        toastr.success('Session has been signed out.');
                        thisClass.datatable.ajax.reload(null, false);
                    } else {
                        toastr.error('Unexpected error occurred. Please try it again later or contact our support team.');
                    }
                }
            });
        });
    }
}
window.ActiveSessionsAppDatatable = ActiveSessionsAppDatatable;